import { createContext } from "react"
import type { Site } from "@lib/types"

export const SiteContext = createContext<Site | any>(null)
